import {
  DOCUMENTS_PATH,
  ListDocumentsResponse,
  listDocumentsResponseSchema,
} from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

/** The catalogue's endpoint (QZ-D107). */
export const documentApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    listDocuments: builder.query<ListDocumentsResponse, void>({
      query: () => DOCUMENTS_PATH,
      transformResponse: (response: unknown) => listDocumentsResponseSchema.parse(response),
      providesTags: ['DocumentList'],
    }),
  }),
});

export const { useListDocumentsQuery } = documentApi;
